import { jsx as i } from "react/jsx-runtime";
import { c as d } from "../index-rKuIKazb.js";
import { useTheme as m } from "../ThemeProvider/index.js";
import '../assets/index18.css';const l = "_layout_19vi2_2", v = "_centered_19vi2_6", p = "_h1_19vi2_10", u = "_h2_19vi2_21", y = "_h3_19vi2_32", f = "_h4_19vi2_43", k = "_dark_19vi2_54", e = {
  layout: l,
  centered: v,
  h1: p,
  h2: u,
  h3: y,
  h4: f,
  dark: k
}, T = (t) => {
  const { centered: o, children: s, className: n, id: c, size: _ = "h1", tagType: a } = t, r = m(), h = d(
    e[r],
    e.layout,
    e[_],
    o && e.centered,
    n
  );
  return /* @__PURE__ */ i(a || "div", { className: h, id: c, children: s });
};
export {
  T as default
};
